import { getAddACollegeBlacklists } from '@scoir/my-colleges/lane-grouping'
import { find, get } from 'lodash'

import api from 'common/api'
import { generateEventDataHeader } from 'common/event-data-helper'

export const getSelector = (CollegeScid) => ({ CollegeScid })

export const followingProspectId = (scid, prospects = {}) => {
  const followedCollege = find(prospects.following, getSelector(scid))
  return get(followedCollege, 'Id')
}

export const useUnfollow = ({ scid, prospects }) => {
  const id = followingProspectId(scid, prospects)
  return (eventData) => {
    return postUnfollow(id, eventData)
  }
}

export const unfollow = (scid, prospects, eventData) => {
  const id = followingProspectId(scid, prospects)
  return postUnfollow(id, eventData)
}

export const postUnfollow = (id, eventData) => {
  const options = generateEventDataHeader(eventData)
  return api.post(`/api/my_prospects/${id}/dismiss`, undefined, options)
}

export const follow = (scid, eventData) => {
  const options = generateEventDataHeader(eventData)
  return api.post(`/api/my_prospects/${scid}/following`, undefined, options)
}

export const useFollow = ({ scid }) => {
  return (eventData) => follow(scid, eventData)
}

export const getFollowingBlacklist = (groups) => {
  return getAddACollegeBlacklists(groups, {
    following: ['applied', 'applying', 'following'],
  })
}
